module.exports = __webpack_public_path__ + "img/logo-elitisti.4957ac23.svg";